import { Container } from '../components';
import { HeaderPages, SliderTestimonials } from '../components';
import styled from 'styled-components';
const Testimoials = () => {
  return (
    <Container type="like">
      <ContainerStyle>
        <HeaderPages title="Client Reviews" shadow="Cl" />
        <SliderTestimonials />
      </ContainerStyle>
    </Container>
  );
};

export default Testimoials;

const ContainerStyle = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 8rem;
  align-items: center;
  width: 95%;
  height: 100%;
  max-width: 128rem;
`;
